
import './modules/validate'

import './modules/calc'

import './modules/setCountry'



// WEBPACK FOOTER //
// ./src/js/main.js